import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ContractForm} from '../../models/contract.models';
import {DeliveryDateError} from '../contract.models';
import {ContractCreateService} from '../services/contract-create.service';
import {LoadingButtonEvent} from '../../../../common/loading-button/loading-button.component';

@Component({
    selector: 'contract-create-delivery-date-error-modal',
    templateUrl: './contract-create-delivery-date-error-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContractCreateDeliveryDateErrorModalComponent {
  @Input() errors: DeliveryDateError[];
  @Input() form: ContractForm;
  @Input() workflowId: number;
  @Input() customerId: number;
  showGoldPriceMissingModal: boolean = false;

  constructor(private activeModal: NgbActiveModal,
              private contractCreateService: ContractCreateService) {
  }

  close(): void {
    this.activeModal.dismiss();
  }

  handleGoldPriceMissingModalClose(response: 'force' | 'abort'): void {
    this.showGoldPriceMissingModal = false;
    if (response === 'force') {
      this.force(null, true);
    }
  }

  force(clb?: LoadingButtonEvent, forceNoGoldPrice?: boolean): void {
    const callbackHook = () => {
      if (clb) {
        clb.callback(false);
      }
    };

    const successHook = () => {
      if (clb) {
        clb.callback(false);
      }
      this.activeModal.close();
    };

    const deliveryErrorsHook = (errors: DeliveryDateError[]) => {
      this.errors = errors;
    };

    const goldPriceErrorHook = (): void => {
      this.showGoldPriceMissingModal = true;
    };

    this.contractCreateService.create(
      this.workflowId,
      this.customerId,
      true,
      forceNoGoldPrice ?? false,
      this.form,
      goldPriceErrorHook,
      deliveryErrorsHook,
      successHook,
      callbackHook
    );
  }

}
